import { useCallback, useEffect, useRef, useState } from "react";
import TableComponent from "../html/table";
import NoPortalDataIllustration from "./NoPortalData";
import { getDataManagerObj } from "../../services/dataManager";
import { Query } from "@syncfusion/ej2-data";
import _ from "lodash";

function WidgetTableTile({ portalId, projectId, filterData, widgetName, widget }) {
  const { headers, url, resourceType } = widget;
  const [showIllustration] = useState(false);
  const tableRef = useRef();

  const dataManagerService = getDataManagerObj(url);
  const tableQuery = new Query().addParams("projectId", projectId).skip(0).take(5).requiresCount();
  if (resourceType) {
    tableQuery.addParams("resourceType", resourceType);
  }

  useEffect(() => {
    if (tableRef.current) {
      const query = new Query()
        .addParams("projectId", projectId)
        .addParams("portalId", portalId)
        .take(5)
        .requiresCount()
        .skip(_.get(filterData, `${widgetName}.skip`, 0));
      if (resourceType) {
        query.addParams("resourceType", resourceType);
      }
      tableRef.current.query = query;
    }
  }, [filterData[widgetName], projectId]);

  const getTable = useCallback(
    () => (
      <div>
        <TableComponent
          ref={tableRef}
          allowSelection={false}
          headerColumns={headers}
          query={tableQuery}
          dataSource={dataManagerService}
        />
      </div>
    ),
    [],
  );

  return showIllustration ? <NoPortalDataIllustration module={widgetName} /> : getTable();
}

export default WidgetTableTile;
